import { useEffect, useRef, useState } from "react";

function PullToRefresh({ children, onRefresh }) {
  const startY = useRef(0);
  const pulling = useRef(false);
  const [pullDistance, setPullDistance] = useState(0);
  const [refreshing, setRefreshing] = useState(false);

  const progress = Math.min(pullDistance / 80, 1);
  const ready = pullDistance >= 70;

  useEffect(() => {
    const handleTouchStart = (e) => {
      if (window.scrollY === 0) {
        startY.current = e.touches[0].clientY;
        pulling.current = true;
      }
    };

    const handleTouchMove = (e) => {
      if (!pulling.current || refreshing) return;

      const currentY = e.touches[0].clientY;
      const distance = currentY - startY.current;

      if (distance > 0 && window.scrollY === 0) {
        setPullDistance(Math.min(distance, 100));
      }
    };

    const handleTouchEnd = async () => {
      if (!pulling.current) return;

      pulling.current = false;

      if (pullDistance >= 70) {
        if (navigator.vibrate) {
          navigator.vibrate(12);
        }

        setRefreshing(true);
        setPullDistance(80);

        try {
if (onRefresh) {
  await onRefresh();
} else {
  await new Promise((resolve) => setTimeout(resolve, 600));
}
        } finally {
          setTimeout(() => {
            setRefreshing(false);
            setPullDistance(0);
          }, 350);
        }
      } else {
        setPullDistance(0);
      }
    };

    window.addEventListener("touchstart", handleTouchStart, { passive: true });
    window.addEventListener("touchmove", handleTouchMove, { passive: true });
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [pullDistance, refreshing, onRefresh]);

  return (
    <>
      <div
        style={{
          ...indicatorWrapStyle,
          transform: `translate(-50%, ${pullDistance - 86}px)`,
          opacity: pullDistance > 8 || refreshing ? 1 : 0,
        }}
      >
        <div
          style={{
            ...logoBubbleStyle,
            transform: `scale(${0.82 + progress * 0.18}) rotate(${
              refreshing ? 360 : progress * 18
            }deg)`,
            borderColor: ready || refreshing ? "#e10600" : "#333",
          }}
        >
          MBID
        </div>

        <span style={labelStyle}>
          {refreshing
            ? "Refreshing"
            : ready
            ? "Release to refresh"
            : "Pull to refresh"}
        </span>
      </div>

      <div>{children}</div>
    </>
  );
}

const indicatorWrapStyle = {
  position: "fixed",
  top: "calc(12px + env(safe-area-inset-top))",
  left: "50%",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  backgroundColor: "rgba(18,18,18,0.94)",
  color: "white",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "999px",
  padding: "8px 14px 8px 8px",
  fontSize: "12px",
  fontWeight: "700",
  zIndex: 10000,
  transition: "transform 0.2s ease, opacity 0.2s ease",
  boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
  pointerEvents: "none",
};

const logoBubbleStyle = {
  width: "34px",
  height: "34px",
  borderRadius: "999px",
  border: "1px solid #333",
  backgroundColor: "#111",
  color: "#e10600",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "10px",
  fontWeight: "900",
  letterSpacing: "-0.5px",
  transition: "transform 0.2s ease, border-color 0.2s ease",
};

const labelStyle = {
  whiteSpace: "nowrap",
};

export default PullToRefresh;